export const USER_ROLES = Object.freeze({
  superAdmin: 'SUPER_ADMIN',
  brandAdmin: 'BRAND_ADMIN',
  agency: 'AGENCY',
  regionalAdmin: 'REGIONAL_ADMIN',
  groupAdmin: 'GROUP_ADMIN',
  location: 'LOCATION',
})
